<template>


<div class="container">

    <div class="alert alert-warning my-5 text-center">Mobile version is under development. Please open this app in a desktop computer.</div>


</div>

</template>
<script>

  import Vue from 'vue'

  export default {
    name: 'mobile',
    data() {
      return {
      }
    },
    methods:{
    },
    mounted(){
        if(!isMobile()){
        this.$router.push('/');
        }

    }

  }



</script>

<style scoped>

</style>
